import { api } from './api'
import {
  PortalUser,
  PortalLoginCredentials,
  PortalAuthTokens,
  PortalRegistrationRequest,
  PortalRegistrationResponse,
  PortalPasswordChangeRequest,
  PortalPasswordResetRequest,
  PortalPasswordResetConfirmRequest,
  PortalUserUpdate,
} from '@/types'

export const portalAuthApi = {
  login: async (credentials: PortalLoginCredentials): Promise<PortalAuthTokens & { user: PortalUser }> => {
    const formData = new URLSearchParams()
    formData.append('username', credentials.email)
    formData.append('password', credentials.password)

    return api.post('/portal/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
  },

  loginJson: async (credentials: PortalLoginCredentials): Promise<PortalAuthTokens & { user: PortalUser }> => {
    return api.post('/portal/auth/login/json', credentials)
  },

  register: async (data: PortalRegistrationRequest): Promise<PortalRegistrationResponse> => {
    return api.post('/portal/auth/register', data)
  },

  verifyEmail: async (token: string): Promise<PortalUser> => {
    return api.post('/portal/auth/verify-email', { token })
  },

  refreshToken: async (refreshToken: string): Promise<{ access_token: string; refresh_token: string }> => {
    return api.post('/portal/auth/refresh', { refresh_token: refreshToken })
  },

  getCurrentUser: async (): Promise<PortalUser> => {
    return api.get('/portal/me')
  },

  updateProfile: async (data: PortalUserUpdate): Promise<PortalUser> => {
    return api.patch('/portal/me', data)
  },

  changePassword: async (data: PortalPasswordChangeRequest): Promise<void> => {
    return api.post('/portal/auth/password/change', data)
  },

  requestPasswordReset: async (data: PortalPasswordResetRequest): Promise<{ message: string }> => {
    return api.post('/portal/auth/password/reset-request', data)
  },

  resetPassword: async (data: PortalPasswordResetConfirmRequest): Promise<{ message: string }> => {
    return api.post('/portal/auth/password/reset', data)
  },
}
